import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import { HttpClient } from './http-client';
import { dateToUnixTime } from '../utils/DateHelper';
import { DEFAULT_PAGE_SIZE } from './services-constants';

import * as moment from 'moment';
import { PosicionService } from './posicion-service';
import { EntregaService } from './entrega-service';
import { FileSaverService } from './file-saver-service';
import { MonedaService, DOLAR_PESOS_ID, DOLAR_ID, MONEDA_PESIFICACION } from './moneda-service';
import { BehaviorSubject } from 'rxjs';
import {AcopioViewModel, NegocioMetricasViewModel, NegocioViewModel, ResponseGeneric} from '@utils/ViewModels';
import {
  GenericFilter,
  GenFilterAcopio, GenFilterAutorizante, GenFilterCliente,
  GenFilterFechaFromTo, GenFilterNumberFromTo, GenFilterSelect,
  IQuickFilters,
  NC,
  NegociosFilter,
  NegociosFiltersAndSort
} from '../components/negocios/negocios/negocio-filter';

// Estos deben coincidir con los valores en la API. Al menos hasta que haya un endpoint que me los traiga
export const NEGOCIO_TYPE_ORDEN = 'Orden';
export const NEGOCIO_TYPE_INTENCION = 'Intencion';
export const NEGOCIO_TYPE_CONTRATO = 'Contratito';
export const NEGOCIO_TYPE_CANJE = 'Canje';
export const NEGOCIO_TYPE_AVISO_GENERADO_ACOPIOS = 'Aviso Genuino (Acopios)';

export const NEGOCIO_TYPE_ORDEN_ID = 1;
export const NEGOCIO_TYPE_INTENCION_ID = 2;
export const NEGOCIO_TYPE_CONTRATO_ID = 3;
export const NEGOCIO_TYPE_CANJE_ID = 4;
export const NEGOCIO_TYPE_AVISO_GENERADO_ACOPIOS_ID = 5;
export const NEGOCIO_TYPE_NEGOCIO_OLVIDADO_ID = 6;

export const NEGOCIO_TYPES = [
  {id: 1, type: 'Orden'},
  {id: 2, type: 'Intencion'},
  {id: 3, type: 'Contratito'},
  {id: 4, type: 'Canje'},
  {id: 5, type: 'Aviso Genuino (Acopios)'},
  {id: 6, type: 'Negocio Olvidado'},
  {id: 7, type: 'Negocio AGD Agro'},
]

export const NEGOCIO_TYPE_DISPO = 'Disponible';
export const NEGOCIO_TYPE_FORWARD = 'Forward';
export const NEGOCIO_TYPE_PAGO_DIFERIDO = 'Pago Diferido';

export const MONEDA_DOLAR_NAME = 'Dolar Estado Unidense';
export const MONEDA_DOLAR_ID = 2;

export const PRODUCTO_SOJA = 'Soja';
export const PRODUCTO_MAIZ = 'Maiz';
export const PRODUCTO_SORGO = 'Sorgo';
export const PRODUCTO_TRIGO = 'Trigo';
export const PRODUCTO_GIRASOL = 'Girasol';

export const ENTREGA_VALUES = {
  ENTREGADO: 'Entregado',
  A_ENTREGAR: 'A entregar',
  N_POSICIONES: 'N posiciones',
  PAGO_DIFERIDO_PESOS: 'Pago Diferido'
};

export const CONFIRMACION_VALUES = {
  ACTIVA: 'Activa',
  MATCHEADA: 'Matcheada',
  CONFIRMADA: 'Confirmada',
  EN_PROCESO: 'En proceso de Autorizacion',
  AUTORIZADA: 'Autorizada',
  NO_AUTORIZADA: 'No Autorizada',
  VENCIDA: 'Vencida',
  ANULADA: 'Anulada',
  GENERACION_AVISO: 'En Generacion de Aviso',
  AVISO_GENERADO: 'Aviso Generado',
  FINALIZADO: 'Finalizado',
  AVISO_CANCELADO: 'Aviso Cancelado'
};

export const NEG_CLASIF = {
  OPORTUNIDADES: 'o',
  COMPROMETIDAS: 'c',
  FINALIZADAS: 'f'
};

export const FUENTE_NAMES = ['Web', 'Mobile', 'Externo'];
export const FUENTE_NAMES_BASIC = ['Web', 'Mobile'];

@Injectable()
export class NegociosService {

  // Flag para indicar que ya se encuentran todas las opciones cargadas desde la API
  private areOptionsLoaded: boolean = false;

  private tipoOptions = [];
  private _tipoOptions: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public $tipoOptions: Observable<any[]> = this._tipoOptions.asObservable();
  private negocioOptions = [];
  private confirmacionOptions: ConfirmationOption[] = [];
  private forwardNegocioID;

  private listSettings:any = null;

  public estadoFilterOptions = [
      {label: 'Activas', Id: 1, active: false, type: 'o', value: CONFIRMACION_VALUES.ACTIVA},
      {label: 'Matcheadas ', Id: 2, active: false, type: 'o', value: CONFIRMACION_VALUES.MATCHEADA},
      {label: 'En proceso de Autorización', Id: 4, active: false, type: 'o', value: CONFIRMACION_VALUES.EN_PROCESO},
      {label: 'Confirmadas', Id: 3, active: false, type: 'c', value: CONFIRMACION_VALUES.CONFIRMADA},
      {label: 'En generación de aviso', Id: 9, active: false, type: 'c', value: CONFIRMACION_VALUES.GENERACION_AVISO},
      {label: 'Avisos generados', Id: 10, active: false, type: 'c', value: CONFIRMACION_VALUES.AVISO_GENERADO},
  ];

  public negocioKanbanFilter = {
    fechaCreacion: {
      desde: null,
      hasta: null
    },
    marcaTemporal: {
      desde: moment().subtract(2, 'week').startOf('day').toDate(),
      hasta: moment().endOf('day').toDate()
    },
    tipoId: null,
    productos: [],
    cosechaId: null,
    negocio: null,
    entrega: null,
    clientes: [],
    acopios: [],
    zonas: [],
    responsables: [],
    autorizantes: [],
    estados: [],
    mercado: null,
    fuente: null,
  };

  public negociosFiltersAndSort: NegociosFiltersAndSort | null;

  public negocioKanbanLastSignalRID = 0;

  public negocioKanbanValues = {
    oportunidades: null,
    comprometidas: null,
    finalizadas: null
  };

  public negocioKanbanLastUpdate: any = null;

  public negociosLastSignalRID = 0;
  DOLAR_PESOS_ID = DOLAR_PESOS_ID;
  DOLAR_ID = DOLAR_ID;
  MONEDA_PESIFICACION = MONEDA_PESIFICACION;

  constructor(
    private httpClient: HttpClient,
    private posicionService: PosicionService,
    private entregaService: EntregaService,
    private fileSaverService: FileSaverService,
    private monedaService: MonedaService
  ) {
    entregaService.ForwardNegocioID.subscribe(newValue => {
      this.forwardNegocioID = newValue;
    });
  }

  loadOptions() {
   this.tipoOptions = [];
    this.getTipoNegocios().subscribe(response => {
      response.forEach(item => {
        this.tipoOptions.push({
          ID: item.Id,
          Tipo_Negocio: item.Tipo,
          Value: item.Tipo
        });
      });
      this._tipoOptions.next(this.tipoOptions);
    });

    this.negocioOptions = [{
      value: 'DISPONIBLE',
      label: NEGOCIO_TYPE_DISPO
    }, {
      value: 'FORWARD',
      label: NEGOCIO_TYPE_FORWARD
    }, {
      value: 'PAGO_DIFERIDO',
      label: NEGOCIO_TYPE_PAGO_DIFERIDO
    }, {
      value: 'BASIS',
      label: 'Basis'
    }];

    this.confirmacionOptions = [{
      ID: 1,
      Value: CONFIRMACION_VALUES.ACTIVA
    }, {
      ID: 2,
      Value: CONFIRMACION_VALUES.MATCHEADA
    }, {
      ID: 3,
      Value: CONFIRMACION_VALUES.CONFIRMADA
    }, {
      ID: 4,
      Value: CONFIRMACION_VALUES.EN_PROCESO
    }, {
      ID: 5,
      Value: CONFIRMACION_VALUES.AUTORIZADA
    }, {
      ID: 6,
      Value: CONFIRMACION_VALUES.NO_AUTORIZADA
    }, {
      ID: 7,
      Value: CONFIRMACION_VALUES.VENCIDA
    }, {
      ID: 8,
      Value: CONFIRMACION_VALUES.ANULADA
    }, {
      ID: 9,
      Value: CONFIRMACION_VALUES.GENERACION_AVISO
    }, {
      ID: 10,
      Value: CONFIRMACION_VALUES.AVISO_GENERADO
    }, {
      ID: 11,
      Value: CONFIRMACION_VALUES.FINALIZADO
    }, {
      ID: 12,
      Value: CONFIRMACION_VALUES.AVISO_CANCELADO
    }];
  }

  private getTipoNegocios() {
    return this.httpClient.get('/api/negocio/tipo')
      .map((response: Response) => {
        return response.json().ResponseData;
      });
  }

  getMonthLabelsInverseMapping() {
    return {
      'ENE': 'enero', 'FEB': 'febrero', 'MAR': 'marzo', 'ABR': 'abril', 'MAY': 'mayo', 'JUN': 'junio',
      'JUL': 'julio', 'AGO': 'agosto', 'SEP': 'septiembre', 'OCT': 'octubre', 'NOV': 'noviembre', 'DIC': 'diciembre'
    };
  }

  getTipoSelectOptions() {
    return [...this.tipoOptions]; // devolvemos una copia;
  }

  getNegocioSelectOptions() {
    return this.negocioOptions;
  }

  getConfirmacionOptions() {
    return this.confirmacionOptions;
  }

  getNegocioTipoOptions() {
    return  [{
        ID: NEGOCIO_TYPE_ORDEN_ID,
        Tipo_Negocio: NEGOCIO_TYPE_ORDEN,
        Value: NEGOCIO_TYPE_ORDEN
      }, {
        ID: NEGOCIO_TYPE_INTENCION_ID,
        Tipo_Negocio: NEGOCIO_TYPE_INTENCION,
        Value: NEGOCIO_TYPE_INTENCION
      }, {
        ID: NEGOCIO_TYPE_CONTRATO_ID,
        Tipo_Negocio: NEGOCIO_TYPE_CONTRATO,
        Value: NEGOCIO_TYPE_CONTRATO
      }, {
        ID: NEGOCIO_TYPE_CANJE_ID,
        Tipo_Negocio: NEGOCIO_TYPE_CANJE,
        Value: NEGOCIO_TYPE_CANJE
      }, {
        ID: NEGOCIO_TYPE_AVISO_GENERADO_ACOPIOS_ID,
        Tipo_Negocio: NEGOCIO_TYPE_AVISO_GENERADO_ACOPIOS,
        Value: NEGOCIO_TYPE_AVISO_GENERADO_ACOPIOS
      }];
  }

  getConfirmacionOptionsByTipo() {
    return {
      [NEGOCIO_TYPE_ORDEN_ID]: [CONFIRMACION_VALUES.ACTIVA, CONFIRMACION_VALUES.CONFIRMADA, CONFIRMACION_VALUES.VENCIDA, CONFIRMACION_VALUES.ANULADA,
        CONFIRMACION_VALUES.GENERACION_AVISO, CONFIRMACION_VALUES.AVISO_GENERADO, CONFIRMACION_VALUES.FINALIZADO, CONFIRMACION_VALUES.AVISO_CANCELADO].map(e =>
        this.confirmacionOptions.find(o => o.Value === e)
      ),
      [NEGOCIO_TYPE_NEGOCIO_OLVIDADO_ID]: [CONFIRMACION_VALUES.ACTIVA, CONFIRMACION_VALUES.CONFIRMADA, CONFIRMACION_VALUES.VENCIDA, CONFIRMACION_VALUES.ANULADA,
        CONFIRMACION_VALUES.GENERACION_AVISO, CONFIRMACION_VALUES.AVISO_GENERADO, CONFIRMACION_VALUES.FINALIZADO, CONFIRMACION_VALUES.AVISO_CANCELADO].map(e =>
        this.confirmacionOptions.find(o => o.Value === e)
      ),
      [NEGOCIO_TYPE_INTENCION_ID]: [CONFIRMACION_VALUES.ACTIVA, CONFIRMACION_VALUES.MATCHEADA, CONFIRMACION_VALUES.EN_PROCESO,
      CONFIRMACION_VALUES.AUTORIZADA, CONFIRMACION_VALUES.NO_AUTORIZADA, CONFIRMACION_VALUES.VENCIDA, CONFIRMACION_VALUES.ANULADA].map(e =>
        this.confirmacionOptions.find(o => o.Value === e)
      ),
      [NEGOCIO_TYPE_CONTRATO_ID]: [CONFIRMACION_VALUES.FINALIZADO, CONFIRMACION_VALUES.ANULADA].map(e =>
        this.confirmacionOptions.find(o => o.Value === e)
      ),
      [NEGOCIO_TYPE_CANJE_ID]: [CONFIRMACION_VALUES.FINALIZADO, CONFIRMACION_VALUES.ANULADA].map(e =>
        this.confirmacionOptions.find(o => o.Value === e)
      ),
      [NEGOCIO_TYPE_AVISO_GENERADO_ACOPIOS_ID]: [CONFIRMACION_VALUES.FINALIZADO, CONFIRMACION_VALUES.ANULADA].map(e =>
        this.confirmacionOptions.find(o => o.Value === e)
      ),
      [NEGOCIO_TYPE_NEGOCIO_OLVIDADO_ID]: [CONFIRMACION_VALUES.ACTIVA, CONFIRMACION_VALUES.CONFIRMADA, CONFIRMACION_VALUES.VENCIDA,
        CONFIRMACION_VALUES.ANULADA, CONFIRMACION_VALUES.EN_PROCESO, CONFIRMACION_VALUES.NO_AUTORIZADA, CONFIRMACION_VALUES.GENERACION_AVISO,
        CONFIRMACION_VALUES.AVISO_GENERADO, CONFIRMACION_VALUES.FINALIZADO, CONFIRMACION_VALUES.AVISO_CANCELADO].map(e =>
        this.confirmacionOptions.find(o => o.Value === e)
      ),
    };
  }

  saveListSettings(quickFilters, filters, sortOrder?, sortColumn?) {
    this.listSettings = {
      quickFilters: {...quickFilters},
      filters: {...filters}
    };
    if (sortOrder) {
      this.listSettings.sortOrder = {...sortOrder};
    }
    if (sortColumn) {
      this.listSettings.sortColumn = sortColumn;
    }
  }

  getListSettings() {
    return this.listSettings;
  }

  resetListSettings() {
    this.listSettings = null;
  }

  buildFiltersRequest(page: number, fromDate: Date, toDate: Date, columnOrder: string,
    ascendingOrder: number, filters: any, quickFilters: any
  , pageSize) {
    const from = filters.fecha ?
      dateToUnixTime(moment(filters.fecha.startDate).startOf('day').toDate()) :
      dateToUnixTime(fromDate);
    const to = filters.fecha ?
      dateToUnixTime(moment(filters.fecha.endDate).endOf('day').toDate()) :
      dateToUnixTime(toDate);

    let request: any = {
      FechaFrom: from,
      FechaTo: to,
      PageSize: pageSize,
      PageNumber: page,
      AscendingOrder: ascendingOrder === 0 ? false : true,
      ColumnOrder: columnOrder,
      UserId: localStorage.getItem('userId')
    };

    if (quickFilters.Hoy) {
      request.FilterConfirmacionFecha = {
        Desde: dateToUnixTime(moment().startOf('day').local().toDate()),
        Hasta: dateToUnixTime(moment().endOf('day').toDate())
      };
    }

    if (quickFilters.Ordenes || quickFilters.Intenciones) {
      request.FilterTipo = this.tipoOptions.filter(t =>
        (quickFilters.Ordenes && t.Tipo_Negocio === NEGOCIO_TYPE_ORDEN) ||
        (quickFilters.Intenciones && t.Tipo_Negocio === NEGOCIO_TYPE_INTENCION)
      ).map(t => t.ID);
    }

    if (quickFilters.Confirmadas || quickFilters.Vencidas) {
      request.FilterConfirmacion = [];
      if (quickFilters.Confirmadas) {
        request.FilterConfirmacion.push(this.confirmacionOptions.find(o => o.Value === CONFIRMACION_VALUES.CONFIRMADA).ID);
      }
      if (quickFilters.Vencidas) {
        request.FilterConfirmacion.push(this.confirmacionOptions.find(o => o.Value === CONFIRMACION_VALUES.VENCIDA).ID);
      }
    }

    if (quickFilters.Matches) {
      request.FilterMatch = true;
    }

    if (filters.tipo) {
      request.FilterTipo = filters.tipo.map(x => x.ID);
    }
    if (filters.cliente) {
      request.FilterCliente = filters.cliente.map(c => c.Id);
    }
    if (!filters.producto) {
      request.FilterProducto = [];
    } else {
      request.FilterProducto = [filters.producto.model1];
    }

    if (filters.tns) {
      request.FilterToneladas = {
        MinValue: filters.tns.model1,
        MaxValue: filters.tns.model2
      };
    }
    if (filters.negocio) {
      request.FilterNegocio = filters.negocio.model1 === 'DISPONIBLE' ? 'D' : (filters.negocio.model1 === 'PAGO_DIFERIDO' ? 'P' : 'F');
    }
    if (filters.entrega) {
      if (filters.entrega.model2.id) {
        request.FilterEntrega = filters.entrega.model2.id;
      } else {
        request.FilterEntrega = filters.entrega.model2.entregaId;
        request.FilterPosicion = filters.entrega.model2.idPos;
      }
    }
    if (filters.cosecha) {
      request.FilterCosecha = filters.cosecha.model1;
    }
    if (filters.moneda) {
      if (filters.moneda.model1 === this.DOLAR_PESOS_ID) {
        request.FilterMoneda = this.DOLAR_ID;
        request.FilterPesificar = 1;
      } else {
        request.FilterMoneda = filters.moneda.model1;
      }
    }
    if (filters.base) {
      request.FilterBase = {
        MinValue: filters.base.model1,
        MaxValue: filters.base.model2
      };
    }
    if (filters.precio) {
      request.FilterPrecioIdea = {
        MinValue: filters.precio.model1,
        MaxValue: filters.precio.model2
      };
    }
    if (filters['precio-especial']) {
      request.FilterPrecioEspecial = {
        MinValue: filters['precio-especial'].model1,
        MaxValue: filters['precio-especial'].model2
      };
    }
    if (filters.match) {
      request.FilterMatch = filters.match.model1;
    }
    if (filters['confirmación']) {
      request.FilterConfirmacion = filters['confirmación'].map(o => o.ID);
    }
    // Si se pusieron filtros para la columna de 'Marca Temporal' y no está encendido el filtro rápido 'Hoy'
    if (filters.hora && !quickFilters.Hoy) {
      request.FilterConfirmacionFecha = {
        Desde: dateToUnixTime(moment(filters.hora.startDate).startOf('day').toDate()),
        Hasta: dateToUnixTime(moment(filters.hora.endDate).endOf('day').toDate())
      };
    }
    if (filters.responsable) {
      request.FilterResponsable = filters.responsable.map(r => r.UserId);
    }
    if (filters.autorizante) {
      request.FilterAutorizante = filters.autorizante.model1 === 'AUTO' ? [0] : filters.autorizante.model2.map(r => r.UserId);
    }
    if (filters.acopio) {
      request.FilterAcopio = filters.acopio.map(a => a.Id);
    }
    if (filters.vencimiento) {
      request.FilterVencimiento = {
        Desde: dateToUnixTime(moment(filters.vencimiento.startDate).startOf('day').toDate()),
        Hasta: dateToUnixTime(moment(filters.vencimiento.endDate).endOf('day').toDate())
      };
    }
    if (filters['zona']) {
      request.FilterZona = filters['zona'].map(o => o.ID);
    }

    if (filters['mercado']) {
      request.MercadoId = filters['mercado'].model1;
    }

    if (filters['fuente']) {
      request.FuenteId = filters['fuente'].model1;
    }

    if (filters['fecha-estado']) {
      request.FechaEstado = {
        From: moment(filters['fecha-estado'].startDate).startOf('day').toDate(),
        To: moment(filters['fecha-estado'].endDate).endOf('day').toDate()
      };
    }

    return request;
  }

  getNegocios(page: number, fromDate: Date, toDate: Date, columnOrder: string,
    ascendingOrder: number, filters: any, quickFilters: any, pageSize
  ) {
    const request = this.buildFiltersRequest(page, fromDate, toDate, columnOrder, ascendingOrder, filters, quickFilters, pageSize);

    return this.httpClient.post('/api/negocio/filter', request)
      .map((response: Response) => {
        const ret = response.json().ResponseData;
        ret.forEach(x => x.Moneda = this.getNegocioMoneda(x));
        return { ResponseData: ret};
      });
  }

  getMetricas(fromDate: Date, toDate: Date, columnOrder: string,
    ascendingOrder: number, filters: any, quickFilters: any
  ): Observable<NegocioMetricasViewModel> {
    const request = this.buildFiltersRequest(0, fromDate, toDate, columnOrder, ascendingOrder, filters, quickFilters, DEFAULT_PAGE_SIZE);

    return this.httpClient.post('/api/negocio/metricas', request)
      .map((response: Response) => {
        return response.json().ResponseData;
      });
  }

  getActividad(negocioId: number, page: number = 0) {
    return this.httpClient.get(`/api/actividad/negocio/${negocioId}/${DEFAULT_PAGE_SIZE}/${page}`)
      .map((response: Response) => {
        return response.json();
      });
  }

  swapNegocioType(id: number) {
    return this.httpClient.put(`/api/negocio/swap-type/${id}`, {})
      .map((response: Response) => {
        return response.json();
      });
  }

  addSpecialPrice(id: number, price: number) {
    return this.httpClient.put(`/api/negocio/set-price/${id}/${price}`, {})
      .map((response: Response) => {
        return response.json();
      });
  }

  deleteNegocio(id: string, comentario: string) {
    const obj = {
      Id: id,
      Comentario: comentario
    };
    return this.httpClient.post(`/api/negocio/cancel`, obj)
      .map((response: Response) => {
        return response.json();
      });
  }

  addNegocio(negocio, duplicated: boolean = false) {
    const payload = {
      ...negocio,
    };

    if (duplicated) {
      return this.httpClient.post('/api/negocio/clone', payload)
        .map((response: Response) => {
          return response.json();
        });
    } else {
          return this.httpClient.post('/api/negocio/', payload)
          .map((response: Response) => {
            return response.json();
          });
    }
  }

  editNegocio(negocio) {
    const payload = {
      ...negocio,
      Pesificar: negocio.MonedaId === DOLAR_PESOS_ID ? 1 : 0
    };

    if (payload.Pesificar) {
      payload.MonedaId = DOLAR_ID;
    }

    return this.httpClient.put('/api/negocio/', payload)
      .map((response: Response) => {
        return response.json();
      });
  }

  getNegocio(id: number) {
    return this.httpClient.get(`/api/negocio/${id}`)
      .map((response: Response) => {
        return {ResponseData: this.serializeNegocioMoneda(response.json().ResponseData)};
      });
  }

  setCurrentNegocio(id: number) {
    return this.httpClient.post(`/api/user/current-negocio/${id}`, {})
      .map((response: Response) => {
        return response.json();
      });
  }

  removeCurrentNegocio() {
    return this.httpClient.post(`/api/user/remove-current-negocio`, {})
      .map((response: Response) => {
        return response.json();
      });
  }

  confirmNegocio(id: number) {
    return this.httpClient.put(`/api/negocio/confirm-order/${id}`, {})
      .map((response: Response) => {
        return response.json();
      });
  }

  authorizeNegocio(id: number) {
    return this.httpClient.put(`/api/negocio/authorize-order/${id}`, {})
      .map((response: Response) => {
        return response.json();
      });
  }

  unauthorizeNegocio(id: number) {
    return this.httpClient.put(`/api/negocio/unauthorize-order/${id}`, {})
      .map((response: Response) => {
        return response.json();
      });
  }

  requestAuthorization(id: number) {
    return this.httpClient.post(`/api/negocio/request-authorization/${id}`, {})
      .map((response: Response) => {
        return response.json();
      });
  }

  registerNegociosCall(contactoId, negocioId) {
    const userId = localStorage.getItem('userId');
    return this.httpClient.post(`/api/negocio/register-call/${userId}/${contactoId}/${negocioId}`, null)
        .map((response: Response) => {
            return response.json();
        });
  }

  IsBefore16() {
  return this.httpClient.get(`/api/negocio/before-work-time`)
    .map((response: Response) => {
      return response.json();
    });
  }

  rejectSpecialPrice(id: number) {
    const userId = localStorage.getItem('userId');
    return this.httpClient.post(`/api/negocio/reject-price/${userId}/${id}`, {})
      .map((response: Response) => {
        return response.json();
      });
  }

  exportToExcel(page: number, fromDate: Date, toDate: Date, columnOrder: string,
                ascendingOrder: number, filters: any, quickFilters: any, pageSize: number) {
    const request = this.buildFiltersRequest(page, fromDate, toDate, columnOrder, ascendingOrder, filters, quickFilters, pageSize);
    return this.httpClient.getFiles('/api/negocio/get-excel', request)
      .map((response: Response) => {
        return this.fileSaverService.SaveToFileSystem(response);
      });
  }

  getNegocioKanban(type, page) {
    return this.httpClient.post('/api/negocio/filter-kanban', this.getNegocioKanbanFilter(type, page))
      .map((response: Response) => {
      // TODO: integrar esto con la solucion de Pesificar una vez sea deployado todo a Stage
        const ret = response.json().ResponseData;
        if (ret.length && ret[0].hasOwnProperty('Pesificar')) {
          ret.forEach(x => x.Moneda = x.Pesificar ? {ID: -1, Moneda: 'Dólares a Pesificar', Simbolo: 'u$p' } : x.Moneda);
        }
        return ret;
      });
  }

  getNegocioKanbanFilter(type, page) {
    const finalFilter: any = {
      FechaFrom: this.negocioKanbanFilter.fechaCreacion.desde != null ?
        moment(this.negocioKanbanFilter.fechaCreacion.desde).unix() : moment().startOf('day').unix(),
      FechaTo: this.negocioKanbanFilter.fechaCreacion.hasta != null ?
        moment(this.negocioKanbanFilter.fechaCreacion.hasta).unix() : moment().endOf('day').unix(),
      FilterTipo: this.negocioKanbanFilter.tipoId != null ? [this.negocioKanbanFilter.tipoId] : [],
      FilterProducto: this.negocioKanbanFilter.productos,
      FilterCosecha: this.negocioKanbanFilter.cosechaId,
      FilterCliente: this.negocioKanbanFilter.clientes.map(x => x.Id),
      FilterAcopio: this.negocioKanbanFilter.acopios.map(x => x.Id),
      FilterZona: this.negocioKanbanFilter.zonas,
      FilterResponsable: this.negocioKanbanFilter.responsables.map(x => x.UserId),
      FilterAutorizante: this.negocioKanbanFilter.autorizantes.map(x => x.UserId),
      FilterConfirmacion: type === NEG_CLASIF.FINALIZADAS ? [11] :
        this.estadoFilterOptions.filter(x => x.type === type && x.active).length > 0 ?
          this.estadoFilterOptions.filter(x => x.type === type && x.active).map(x => x.Id) :
          this.estadoFilterOptions.filter(x => x.type === type).map(x => x.Id),
      PageSize: 10,
      PageNumber: page,
      AscendingOrder: false,
      ColumnOrder: 'HoraConfirmacion',
      UserId: Number.parseInt(localStorage.getItem('userId'), 10),
      MercadoId: this.negocioKanbanFilter.mercado,
      FuenteId: this.negocioKanbanFilter.fuente,
    };
    if (this.negocioKanbanFilter.negocio != null) {
      finalFilter['FilterNegocio'] = this.negocioKanbanFilter.negocio.charAt(0);
    }
    if (this.negocioKanbanFilter.entrega != null) {
      finalFilter['FilterEntrega'] = this.negocioKanbanFilter.negocio.charAt(0) === 'D' ? this.negocioKanbanFilter.entrega :
        this.negocioKanbanFilter.negocio.charAt(0) === 'F' ? 3 : 4;
    }
    if (this.negocioKanbanFilter.negocio !== null && (this.negocioKanbanFilter.negocio.charAt(0) === 'F' || this.negocioKanbanFilter.negocio.charAt(0) === 'P') && this.negocioKanbanFilter.entrega != null) {
      finalFilter['FilterPosicion'] = this.negocioKanbanFilter.entrega;
    }
    if (this.negocioKanbanFilter.marcaTemporal.desde != null) {
      finalFilter['FilterConfirmacionFecha'] = {
        Desde: this.negocioKanbanFilter.marcaTemporal.desde != null ?
          moment(this.negocioKanbanFilter.marcaTemporal.desde).unix() : null,
        Hasta: this.negocioKanbanFilter.marcaTemporal.hasta != null ?
          moment(this.negocioKanbanFilter.marcaTemporal.hasta).unix() : null
      };
    }
    return finalFilter;
  }

  resetKanbanFilter() {
    this.negocioKanbanFilter = {
      fechaCreacion: {
        desde: null,
        hasta: null
      },
      marcaTemporal: {
        desde: moment().subtract(2, 'week').startOf('day').toDate(),
        hasta: moment().endOf('day').toDate()
      },
      tipoId: null,
      productos: [],
      cosechaId: null,
      negocio: null,
      entrega: null,
      clientes: [],
      acopios: [],
      zonas: [],
      responsables: [],
      autorizantes: [],
      estados: [],
      mercado: null,
      fuente: null,
    };
  }

  getAcopiosByCliente(clienteId) {
    return this.httpClient.get(`/api/acopios/acopios-by-user-rol-and-client/${clienteId}`)
      .map((response: Response) => {
        const res = response.json() as ResponseGeneric<AcopioViewModel[]>
        return res.ResponseData;
      });
  }

  serializeNegocioMoneda(negocio: any) {
    negocio.Moneda = negocio.Pesificar ? this.MONEDA_PESIFICACION : negocio.Moneda;
    return negocio;
  }

  getNegocioMoneda(negocio: any) {
    return negocio.Pesificar ? this.MONEDA_PESIFICACION : negocio.Moneda;
  }

  validarNegOlvidado(negocio) {
    return this.httpClient.post(`/api/negocio/validate-matching`, negocio)
    .map((response: Response) => {
	  return response.json().ResponseData;
    });
  }

  newExportToExcel(page: number, pageSize: number, sortColumn: string, sortOrder: boolean, filters: NegociosFilter, quickFilters: IQuickFilters) {
    const payload = this.buildNEWNegociosFilterRequest(page, pageSize, sortColumn, sortOrder, filters, quickFilters);
    return this.httpClient.getFiles('/api/negocio/get-excel', payload)
      .map((response: Response) => {
        return this.fileSaverService.SaveToFileSystem(response);
      });
  }

  getNEWMetricas(page: number, pageSize: number, sortColumn: string, sortOrder: boolean, filters: NegociosFilter, quickFilters: IQuickFilters): Observable<NegocioMetricasViewModel> {
    const payload = this.buildNEWNegociosFilterRequest(page, pageSize, sortColumn, sortOrder, filters, quickFilters);
    return this.httpClient.post('/api/negocio/metricas', payload)
      .map((response: Response) => {
        return response.json().ResponseData;
      });
  }

  getNewNegocios(page: number, pageSize: number, sortColumn: string, sortOrder: boolean, filters: NegociosFilter, quickFilters: IQuickFilters) {
    const payload = this.buildNEWNegociosFilterRequest(page, pageSize, sortColumn, sortOrder, filters, quickFilters);
    return this.httpClient.post('/api/negocio/filter', payload)
      .map((response: Response) => {
        const ret = response.json().ResponseData as NegocioViewModel[];
        ret.forEach(x => x.Moneda = this.getNegocioMoneda(x));
        return ret;
      });
  }

  buildNEWNegociosFilterRequest(page: number, pageSize: number, sortColumn: string, sortOrder: boolean, filters: NegociosFilter, quickFilters: IQuickFilters) {
    const creacionFilter = filters.getFilter(NC.creacion.name).data as GenFilterFechaFromTo;
    const marcaTemporal = quickFilters.Hoy ? null : filters.getFilter(NC.hora.name).data as GenFilterFechaFromTo;
    const fechaEstadoFilter = filters.getFilter(NC.fechaEstado.name).data as GenFilterFechaFromTo;
    const filterBase = filters.getFilter(NC.base.name).data as GenFilterNumberFromTo;

    const filterEntrega = filters.getFilter(NC.entrega.name).data as GenFilterSelect;
    const entregaRawValue = filterEntrega ? JSON.parse(filterEntrega.rawValue) : null;
    const filterEntregaFinal = entregaRawValue ? (entregaRawValue.ID ? entregaRawValue.ID : entregaRawValue.Entrega_Id) : null;
    const filterPosicion = entregaRawValue !== null && entregaRawValue.EsPosicion ? entregaRawValue.ID_POS : null;

    const filterMatch = filters.getFilter(NC.match.name).data;
    const filterNegocioGeneric = filters.getFilter(NC.negocio.name).data as GenFilterSelect;
    let filterNegocio: string = null;
    if (filterNegocioGeneric !== null) {
      filterNegocio = filterNegocioGeneric.Id === 'DISPONIBLE' ? 'D' : (filterNegocioGeneric.Id === 'PAGO_DIFERIDO' ? 'P' : 'F');
    }
    const filMonedaBase = filters.getFilter(NC.moneda.name).data as GenFilterSelect;
    let filterMoneda = filMonedaBase ? Number(filMonedaBase.Id) : null;
    let pesificar = 0;
    if (filterMoneda === this.DOLAR_PESOS_ID) {
      filterMoneda = this.DOLAR_ID;
      pesificar = 1;
    }
    const filterPrecioEspecial = filters.getFilter(NC.precioEspecial.name).data as GenFilterNumberFromTo;
    const filterPrecioIdea = filters.getFilter(NC.precio.name).data as GenFilterNumberFromTo;
    const filterProducto = filters.getFilter(NC.producto.name).data as GenFilterSelect;

    let filterTipo: number[] = [];
    if (quickFilters.Ordenes || quickFilters.Intenciones) {
      filterTipo = this.tipoOptions.filter(t =>
        (quickFilters.Ordenes && t.Tipo_Negocio === NEGOCIO_TYPE_ORDEN) ||
        (quickFilters.Intenciones && t.Tipo_Negocio === NEGOCIO_TYPE_INTENCION)
      ).map(t => t.ID);
    } else {
      filterTipo = ((filters.getFilter(NC.tipo.name).data as GenFilterSelect[]) || []).map(x => Number(x.Id));
    }

    const filterCosecha = filters.getFilter(NC.cosecha.name).data as GenFilterSelect;

    const filterToneladas = filters.getFilter(NC.tns.name).data as GenFilterNumberFromTo;
    const filterVencimiento = filters.getFilter(NC.vencimiento.name).data as GenFilterFechaFromTo;

    const payload: NegocioFilterPayload = {
      AscendingOrder: sortOrder,
      ColumnOrder: sortColumn,
      FechaEstado: fechaEstadoFilter ? {
        From: moment(fechaEstadoFilter.from).startOf('day').toDate(),
        To: moment(fechaEstadoFilter.to).endOf('day').toDate(),
      } : null,
      FechaFrom: 0,
      FechaTo: 0,
      FilterConfirmacionFecha: marcaTemporal ? {
        Desde: moment(marcaTemporal.from).startOf('day').unix(),
        Hasta: moment(marcaTemporal.to).endOf('day').unix(),
      } : null,
      // Esta key queda siempre en null dado que se usa FilterConfirmacionFecha
      FechaModificacion: null,
      FilterAutorizante: ((filters.getFilter(NC.autorizante.name).data as GenFilterAutorizante[]) || []).map(x => Number(x.Id)),
      FilterBase: filterBase ? {MinValue: filterBase.From, MaxValue: filterBase.To} : null,
      FilterConfirmacion: ((filters.getFilter(NC.confirmacion.name).data as GenFilterSelect[]) || []).map(x => Number(x.Id)),
      FilterCosecha: filterCosecha ? Number(filterCosecha.Id) : null,
      FilterEntrega: filterEntregaFinal,
      FilterMatch: filterMatch !== null ? !!(filterMatch as GenFilterSelect).Id : null,
      FilterNegocio: filterNegocio,
      FilterMoneda: filterMoneda,
      FilterPosicion: filterPosicion,
      FilterPrecioEspecial: filterPrecioEspecial ? {MinValue: filterPrecioEspecial.From, MaxValue: filterPrecioEspecial.To} : null,
      FilterPrecioIdea: filterPrecioIdea ? {MinValue: filterPrecioIdea.From, MaxValue: filterPrecioIdea.To} : null,
      // valor unico, pero acepta array el BE
      FilterProducto: filterProducto ? [Number(filterProducto.Id)] : [],
      FilterResponsable: ((filters.getFilter(NC.responsable.name).data as GenFilterSelect[]) || []).map(x => Number(x.Id)),
      FilterToneladas: filterToneladas ? {MinValue: filterToneladas.From, MaxValue: filterToneladas.To} : null,
      FilterTipo: filterTipo,
      FilterVencimiento: filterVencimiento ? {
        Desde: moment(filterVencimiento.from).startOf('day').unix(),
        Hasta: moment(filterVencimiento.to).endOf('day').unix(),
      } : null,
      FilterZona: ((filters.getFilter(NC.zona.name).data as GenFilterSelect[]) || []).map(x => Number(x.Id)),
      MercadoId: filters.getFilter(NC.mercado.name).data !== null ?
        Number((filters.getFilter(NC.mercado.name).data as GenFilterSelect).Id) : null,
      FuenteId: filters.getFilter(NC.fuente.name).data !== null ?
        Number((filters.getFilter(NC.fuente.name).data as GenFilterSelect).Id) : null,
      PageNumber: page,
      PageSize: pageSize,
      UserId: Number(localStorage.getItem('userId')),
    };

    if (filters.getFilter(NC.cliente.name).data !== null) {
      payload.FilterCliente = ((filters.getFilter(NC.cliente.name).data as GenFilterCliente[]) || []).map(x => Number(x.Id));
    }

    if (filters.getFilter(NC.acopio.name).data) {
      payload.FilterAcopio = ((filters.getFilter(NC.acopio.name).data as GenFilterAcopio[]) || []).map(x => Number(x.Id));
    }

    if (creacionFilter !== null) {
      payload.FechaFrom = moment(creacionFilter.from).startOf('day').unix();
      payload.FechaTo = moment(creacionFilter.to).endOf('day').unix();
    }

    if (quickFilters.Ordenes) {
      payload.Ordenes = quickFilters.Ordenes;
    }
    if (quickFilters.Intenciones) {
      payload.Intenciones = quickFilters.Intenciones;
    }
    if (quickFilters.Hoy) {
      payload.Hoy = quickFilters.Hoy;
    }
    if (quickFilters.Matches) {
      payload.Matches = quickFilters.Matches;
    }
    if (quickFilters.Vencidas) {
      payload.Vencidas = quickFilters.Vencidas;
    }
    if (quickFilters.Confirmadas) {
      payload.Confirmadas = quickFilters.Confirmadas;
    }
    if (pesificar) {
      payload.FilterPesificar = pesificar;
    }

    return payload;
  }

}

export function getFuenteName(id): string {
  switch (id.toString()) {
    case '1':
      return 'Web';
    case '2':
      return 'Mobile';
    case '3':
      return 'Externo';
  }
}

interface ConfirmationOption {
  ID: number;
  Value: string;
}

interface NegocioFilterPayload {
  Hoy?: boolean;
  Ordenes?: boolean;
  Intenciones?: boolean;
  Matches?: boolean;
  Confirmadas?: boolean;
  Vencidas?: boolean;

  PageSize: number;
  PageNumber: number;
  AscendingOrder: boolean;
  ColumnOrder: string;
  UserId: number;
  FilterTipo: number[];
  FilterCliente?: number[];
  FilterAcopio?: number[];
  FilterResponsable: number[];
  FilterAutorizante: number[];
  FilterProducto: number[];
  FilterToneladas: DecimalRangeViewModel;
  FilterNegocio: string;
  FilterEntrega: number | null;
  FilterCosecha: number | null;
  FilterMoneda: number | null;
  FilterBase: DecimalRangeViewModel;
  FilterPrecioEspecial: DecimalRangeViewModel;
  FilterMatch: boolean | null;
  FilterConfirmacion: number[];
  FilterPrecioIdea: DecimalRangeViewModel;
  FilterPosicion: number | null;
  FilterZona: number[];
  FilterPesificar?: number;
  MercadoId: number;
  FuenteId: number;
  FechaFrom: number;
  FechaTo: number;
  FilterVencimiento: DateRangeFilterViewModel;
  FechaEstado: DateFilter | null;
  FilterConfirmacionFecha: DateRangeFilterViewModel;
  FechaModificacion: DateFilter;
}

interface DateRangeFilterViewModel {
  Desde: number;
  Hasta: number;
}

interface DecimalRangeViewModel {
  MinValue: number;
  MaxValue: number;
}

interface DateFilter {
  From: Date | null;
  To: Date | null;
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/negocios-service.ts